import products from './atom';
import {
  getProductById,
  getProductByCategory,
  getProductCategories,
} from './selector';

export { getProductById, getProductByCategory, getProductCategories };
export default products;
